{
  "w": 3,
  "h": 8,
  "rows": [
    "YYY",
    ".w.",
    ".w.",
    ".w.",
    ".w.",
    ".w.",
    ".w.",
    "WWW"
  ],
  "legend": {
    "Y": "C.B_YELLOW",
    "W": "C.B_WHITE",
    "w": "C.WHITE"
  }
}
